import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  setClientBranchesLoading,
  updateFilters,
  updatePagination,
  fetchClientBranches,
} from "@/reducers/clientcommon";

import TableSearch from "../dataTables/TableSearch";

const SearchFilter = () => {
  const {
    showClientBranchesModal,
    clientBranches,
    filters,
    pagination,
    isLoading,
  } = useSelector((state) => state.clientCommon);

  const dispatch = useDispatch();

  const handleSearch = (e) => {
    dispatch(updateFilters({ search: e.target.value }));
  };

  // for search
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      dispatch(setClientBranchesLoading(true));
      dispatch(
        updatePagination({
          ...pagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      dispatch(fetchClientBranches(filters));
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [filters.search]);

  return (
    <div className="mr-1">
      <TableSearch
        val={filters.search}
        cls={`true ${isLoading ? "pointer-events-none" : ""} `}
        handleChange={handleSearch}
      />
    </div>
  );
};

export default SearchFilter;
